export const DOWNLOAD_REPORT = "DOWNLOAD_REPORT";
export const DOWNLOAD_REPORT_SUCCESS = "DOWNLOAD_REPORT_SUCCESS";
export const DOWNLOAD_REPORT_FAILURE = "DOWNLOAD_REPORT_FAILURE";
export const DOWNLOAD_REPORT_RESET = "DOWNLOAD_REPORT_RESET";
